import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
/**
 * ============================================================================
 * MIGRATED FILE — DO NOT EDIT
 * ============================================================================
 *
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/ratingsAndReview/components/DoubleThumbsUpSvgIcon.tsx
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 *
 * @migrated-to academy-content-ui
 * ============================================================================
 */

const DoubleThumbsUpSvgIcon = ({
  color
}) => {
  return /*#__PURE__*/_jsxs("svg", {
    fill: "none",
    height: "18",
    viewBox: "0 0 18 15",
    width: "20",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M10.9189 1.42988C10.9189 1.16678 10.7135 0.953251 10.4604 0.953251L10.4618 0.953728H9.91387C9.69609 0.953728 9.51407 1.11101 9.46639 1.3255L9.13946 2.8521C8.94057 2.52005 8.65269 2.25159 8.3105 2.08276L8.56684 1.12007L8.56867 1.11054C8.70851 0.474719 9.25594 0 9.9102 0H10.4604C11.2201 0 11.8354 0.639631 11.8354 1.4294V4.28915H14.6885C15.6912 4.30202 16.5 5.15041 16.5 6.19565C16.5 6.72221 16.2947 7.19922 15.9624 7.54427C16.014 7.72061 16.042 7.90774 16.042 8.10168C16.042 8.6287 15.8362 9.1057 15.5035 9.45076C15.5555 9.62755 15.5835 9.81471 15.5835 10.0091C15.5835 11.0549 15.0769 11.9412 14.0728 11.9531V10.8959C14.5602 10.8735 14.6491 10.5229 14.6491 10.0106C14.6491 9.61401 14.4157 9.2737 14.0783 9.12785V9.05639C14.1288 9.0653 14.1811 9.07018 14.2342 9.07018C14.744 9.07018 15.1576 8.64027 15.1576 8.11026C15.1576 7.63745 14.8284 7.24423 14.3901 7.16416V7.09272C14.4873 7.12931 14.5924 7.14938 14.7023 7.14938C15.2089 7.14938 15.6193 6.7228 15.6193 6.19613C15.6193 5.66946 15.2089 5.24288 14.7023 5.24288H10.9189V1.42988Z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      d: "M14.0728 11.9531L14.047 11.9529H14.0546L14.0728 11.9531Z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      d: "M10.17 11.9529L10.1586 11.9531L10.1529 11.9529H10.17Z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      d: "M1.41697 6.37399H1.87545C2.38208 6.37399 2.79242 6.80057 2.79242 7.32724V13.0467C2.79242 13.5734 2.38208 14 1.87545 14H1.41697C0.910344 14 0.5 13.5734 0.5 13.0467V7.32724C0.5 6.80057 0.910344 6.37399 1.41697 6.37399ZM6.4603 3.03285C6.71339 3.03285 6.91879 3.24638 6.91879 3.50947V7.32248H10.7022C11.2088 7.32248 11.6192 7.74906 11.6192 8.27573C11.6192 8.8024 11.2088 9.22898 10.7022 9.22898C10.5899 9.22898 10.4826 9.20801 10.3836 9.16988L10.39 9.17226V9.24375C10.8283 9.32383 11.1575 9.71704 11.1575 10.1899C11.1575 10.7199 10.7439 11.1498 10.2341 11.1498C10.1791 11.1498 10.125 11.1445 10.0727 11.135L10.0782 11.136V11.2075C10.4157 11.3533 10.649 11.6936 10.649 12.0902C10.649 12.6025 10.2607 13.0201 9.77331 13.0425H5.08576C4.83268 13.0425 4.62728 12.8289 4.62728 12.5658V7.32295L5.46631 3.40509C5.51399 3.19061 5.69601 3.03332 5.91379 3.03332H6.46168L6.4603 3.03285ZM6.4603 2.0796H5.91012C5.25586 2.0796 4.70843 2.55432 4.56859 3.19013L4.56676 3.19967L3.70939 7.11753C3.70618 7.14851 3.70389 7.18378 3.70389 7.22C3.70389 7.25623 3.70573 7.2915 3.70939 7.32677L3.70893 7.32248V12.5654C3.70893 13.3551 4.32468 13.9952 5.08439 13.9952H9.7701C10.7742 13.9833 11.5834 13.1344 11.5834 12.0887C11.5834 11.8895 11.5541 11.6979 11.4995 11.5173L11.5032 11.5306C11.836 11.1855 12.0419 10.7084 12.0419 10.1813C12.0419 9.98252 12.0126 9.79092 11.9585 9.61076L11.9621 9.6241C12.2945 9.27902 12.4999 8.80192 12.4999 8.27525C12.4999 7.23001 11.6912 6.38162 10.6884 6.36875H7.8353V3.509C7.8353 2.71923 7.22001 2.0796 6.4603 2.0796Z",
      fill: color
    })]
  });
};

/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/ratingsAndReview/components/DoubleThumbsUpSvgIcon.tsx
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
export default DoubleThumbsUpSvgIcon;